// extracted by mini-css-extract-plugin
export var contrastLow = "_28-1";
export var externalLink = "_28-2";
export var externalLinkIcon = "_28-3";
export var link = "_28-0";
export var linkLabel = "_28-4";